export enum DELIVERY_SERVICES {
    SERVICE_ASSEMBLY = 'SERVICE_ASSEMBLY',
    SERVICE_COMPLEX_INSTALL = 'SERVICE_COMPLEX_INSTALL',
    SERVICE_ECOMMERCE = 'SERVICE_ECOMMERCE',
    SERVICE_FRONT_HOME = 'SERVICE_FRONT_HOME',
    SERVICE_GREEN = 'SERVICE_GREEN',
    SERVICE_INSTALL = 'SERVICE_INSTALL',
    SERVICE_PAY_ON_DELIVERY = 'SERVICE_PAY_ON_DELIVERY',
    SERVICE_PICKUP_POINT = 'SERVICE_PICKUP_POINT',
    SERVICE_RECOVERY = 'SERVICE_RECOVERY',
    SERVICE_REGULAR_FRONT_HOME = 'SERVICE_REGULAR_FRONT_HOME',
    SERVICE_RETURN = 'SERVICE_RETURN',
    SERVICE_SELECTED_ROOM = 'SERVICE_SELECTED_ROOM',
    SERVICE_SIMPLE_INSTALL = 'SERVICE_SIMPLE_INSTALL',
    SERVICE_STANDARD_TAXI = 'SERVICE_STANDARD_TAXI',
    SERVICE_UNPACKING = 'SERVICE_UNPACKING',
    SERVICE_WITH_SIGNATURE = 'SERVICE_WITH_SIGNATURE',
    SERVICE_XL_TAXI = 'SERVICE_XL_TAXI',
}
